import { Frame, Img } from "../headliner/DeckShell";
import { brandOf } from "./brands";

/* 03 The stage — salen slik partneren vil se den: 700 i Grieghallen, mottakerens merke på LED-skjermen. Hele bildet er generert i ett
   (scripts/build_stage_plate.py → /images/build-stage-<merke>.webp; ukjent mottaker → generisk plate med Norwegian AI Summit på skjermen).
   Konseptvisualisering — merket i bildet, ikke foto fra et avholdt arrangement. */
export const StageScene = ({ nr, mottaker }) => {
  const r = brandOf(mottaker);
  return (
    <Frame nr={nr} label="The stage" mottaker={mottaker} className="bd-scene hd-dark">
      <Img className="bd-scene-img" src={r.plate} alt="" draggable={false} fetchPriority="high" data-testid="bd-scene-img" />
      <div className="bd-scene-shade" aria-hidden />
      <div className="bd-scene-txt">
        <h2 data-testid="bd-scene-h">Inside this room, {mottaker} owns<br />the moment ideas become software.</h2>
        <p data-testid="bd-scene-p">700 of Norway's decision-makers. One main stage. The live build — built with {mottaker}, credited to {mottaker}, in front of everyone.</p>
      </div>
      <p className="bd-scene-cap" data-testid="bd-scene-cap">Concept visualisation · Grieghallen, Bergen · 13 April 2027</p>
    </Frame>
  );
};
